export default __webpack_public_path__ + "static/media/img11.aadd27d0.png";